<template>
    <!-- 产品服务 -->
    <div class="service-item">
        <div class="title">
            {{ serviceItem.title }}
        </div>
        <div class="content">
            {{ serviceItem.content }}
        </div>
        <div class="case">
            {{ serviceItem.case }}
        </div>
        <swiper class="mySwiper" v-if="images" :options="swiperOption" ref="mySwiper">
            <!-- slides -->
            <swiper-slide v-for="image in serviceItem.images">
                <img :src="require(`@/assets/img/${image}`)" alt="">
            </swiper-slide>

            <div v-show="showButton" class="swiper-pagination " slot="pagination"></div>
            <div v-show="showButton" class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
            <div v-show="showButton" class="swiper-button-next swiper-button-black" slot="button-next"></div>
        </swiper>
    </div>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
    name: 'ServiceItem',
    props: {
        serviceItem: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    components: {
        swiper,
        swiperSlide
    },
    computed: {
        images() {
            return !!this.serviceItem?.images?.length;
        },
        showButton() {
            return this.serviceItem?.images?.length > 4;
        }
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 4,
                //左右点击
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            }
        };
    },
    methods: {
        onSlideChange() {
            console.log('111');
        }
    },
}
</script>
  
<style scoped>
.service-item {
    margin-bottom: 40px;
    padding-bottom: 20px;
    border: 1px solid #AEAEAE;
}

.title {
    padding: 40px 40px 20px;
    font-size: 30px;
}

.content {
    padding: 0 40px 20px;
    font-size: 16px;
    line-height: 30px;
    color: #000;
}

.case {
    padding: 0 40px 40px;
    font-size: 16px;
    line-height: 30px;
    color: #6C6C6C;
}

.swiper-container {
    height: 180px;
}

.swiper-slide {
    display: flex;
    justify-content: center;
    width: 200px;
    height: 135px;
}

.swiper-slide img {
    width: 200px;
    height: 135px;
}

.swiper-pagination {
    left: 50%;
    transform: translate(-50%);
    bottom: 0;
}

.swiper-button-black {
    visibility: hidden;
}

.swiper-container:hover .swiper-button-black {
    visibility: visible;
}
</style>
  